export default __webpack_public_path__ + "static/media/5.97cc38b4.jpg";